import { useEffect, useState } from "react";

import classes from "./AddCabIngredientCard.module.css";

import AddIngredientBar from "../AddCabIngredientBar/AddIngredientBar";
import Modal from "../../../UI/Modal";

import { useIngredients } from '../../../store/IngredientContext';

// component for card when adding ingredients to cabinet
const AddCabIngredientCard = (props) => {
  const { loadedIngredients } = useIngredients();
  
  // const [loadedIngredients, setLoadedIngredients] = useState();
  // const { sendRequest } = useHttpClient();

  // // send request to backend to fetch all ingredients in db
  // useEffect(() => {
  //   const fetchIngredientsRefs = async () => {
  //     try {
  //       const responseData = await sendRequest(
  //         `${process.env.REACT_APP_BACKEND_URL}/cocktails/getAllIngredientRefs`
  //       );
  //       setLoadedIngredients(responseData.ingredients);
  //       console.log(responseData);
  //     } catch (err) {}
  //   };

  //   fetchIngredientsRefs();
  // }, [sendRequest]);


  // sort ingredients into alcoholic and non alcoholic lists
  let alcoholicIngredients;
  let mixerIngredients;

  if (loadedIngredients) {
    var alcohols = [];
    var mixers = [];

    for (var ing of loadedIngredients) {
      if (ing.type_1 === "alcohol") alcohols.push(ing);
      if (ing.type_1 === "mixer") mixers.push(ing);
    }

    alcoholicIngredients = alcohols.map((ingredient) => {
      return <AddIngredientBar key={ingredient._id} ingredient={ingredient} />;
    });

    mixerIngredients = mixers.map((ingredient) => {
      return <AddIngredientBar key={ingredient._id} ingredient={ingredient} />;
    });
  }

  return (
    <Modal onClose={props.onClose}>
      <div className={classes.addCabIngredientCard}>
        <div className={classes.header}>
          <div className={classes.headerCorners}></div>
          <div className={classes.headerTitle}>INGREDIENTS</div>
          <div className={classes.headerCorners}></div>
        </div>
        <div className={classes.body}>
          <div className={classes.sectionHeader}>
            <img
              className={classes.sectionHeaderIcon}
              src={"/assets/ingredients/ingredient_icons/whisky.svg"}
              alt="new"
            />
            <div className={classes.sectionHeaderTitles}>Alcohol</div>
            <img
              className={classes.sectionHeaderIcon}
              src={"/assets/ingredients/ingredient_icons/whisky.svg"}
              alt="new"
            />
          </div>
          {alcoholicIngredients}
          <div className={classes.sectionHeader}>
            <img
              className={classes.sectionHeaderIcon}
              src={"/assets/ingredients/ingredient_icons/mixer.svg"}
              alt="new"
            />
            <div className={classes.sectionHeaderTitles}>Mixers</div>
            <img
              className={classes.sectionHeaderIcon}
              src={"/assets/ingredients/ingredient_icons/mixer.svg"}
              alt="new"
            />
          </div>
          {mixerIngredients}
        </div>
      </div>
    </Modal>
  );
};

export default AddCabIngredientCard;
